import { makeHeadingPropsSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { combinedSettingsSelector, TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types/AppState";
import Component, { type TitleComponentProps } from "./component";

const makeMapStateToProps = () => {
  const headingPropsSelector = makeHeadingPropsSelector(TargetSelector.Entity);
  const settingsSelector = combinedSettingsSelector(TargetSelector.Entity, ["title"]);

  return (state: AppState, props: RootContainerProps): TitleComponentProps => {
    return {
      ...props,
      className: "wsc_heading",
      headingProps: headingPropsSelector(state, props),
      ...settingsSelector(state, props)
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
